<nz-card class="sbi-widget">
  <h4 class="sbi-widget_title">SBI ricevuti</h4>

  <div class="sbi-widget_content" *ngIf="!isLoading && !isEdit">
    <div class="sbi-widget_trend">
      <!-- Inizio Trend a sinistra parte migliorativa -->
      <div class="sbi-widget_trend_ameliorative">
        <button
          (click)="onTrendClick('migliorative')"
          class="sbi-widget_trend_ameliorative_card migliorative"
          [ngClass]="{ active: selectedTrend === 'migliorative' }">
          <img
            class="trend-icon"
            src="assets/images/Sbi/migliorativo.svg"
            alt="" />
          <div class="trend-label">Migliorativi</div>
          <div class="trend-number">{{ migliorativeSbis.length || 0 }}</div>
        </button>

        <div class="sbi-widget_trend_ameliorative_percentage">
          <ng-container *ngIf="trendIsEdited !== 'migliorative'">
            <div
              *ngIf="
                migliorativeSoftSkills && migliorativeSoftSkills.length;
                else noSoftSkills
              ">
              <div
                *ngFor="let softSkill of migliorativeSoftSkills; let i = index"
                class="sbi-widget_trend_ameliorative_percentage_child">
                <img
                  class="trend-icon"
                  [src]="
                    utilityService.getSanitizeUrl(
                      softSkill.argument?.filestorage?.path ?? ''
                    )
                  " />
                <div class="trend-label">{{ softSkill.name }}</div>
                <div class="trend-percentage">{{ softSkill.percentage }}%</div>
              </div>
            </div>

            <!-- Template alternativo -->
            <ng-template #noSoftSkills>
              <div class="no-soft-skills-label">Non ci sono soft skills</div>
            </ng-template>
          </ng-container>

          <!-- Inizio modifica delle competenze trasversali migliorative -->
          <div *ngIf="trendIsEdited === 'migliorative'" class="mt-2">
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="firstReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>
              <input
                class="h-25"
                [(ngModel)]="firstReviewSoftSkills.percentage"
                (ngModelChange)="
                  onPercentageChange($event, firstReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="secondReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>
              <input
                class="h-25"
                [(ngModel)]="secondReviewSoftSkills.percentage"
                (ngModelChange)="
                  onPercentageChange($event, secondReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="thirdReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>
              <input
                class="h-25"
                [(ngModel)]="thirdReviewSoftSkills.percentage"
                (ngModelChange)="
                  onPercentageChange($event, thirdReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
          </div>
          <!-- Fine modifica delle competenze trasversali migliorative -->

          <button class="generic-edit-btn">
            <div
              *ngIf="trendIsEdited !== 'migliorative'"
              (click)="editTrend('migliorative')">
              <img src="assets/images/Sbi/edit.svg" alt="" />
              modifica
            </div>

            <span
              (click)="saveTrend('migliorative')"
              *ngIf="trendIsEdited === 'migliorative'"
              >salva</span
            >
          </button>
        </div>
      </div>
      <!-- Fine Trend a sinistra parte migliorativa -->

      <!-- Inizio Trend a sinistra parte Positiva -->
      <div class="sbi-widget_trend_positive">
        <button
          (click)="onTrendClick('positive')"
          class="sbi-widget_trend_positive_card positive"
          [ngClass]="{ active: selectedTrend === 'positive' }">
          <img class="trend-icon" src="assets/images/Sbi/positivo.svg" alt="" />
          <div class="trend-label">Positivi</div>
          <div class="trend-number">{{ positiveSbis.length || 0 }}</div>
        </button>

        <div class="sbi-widget_trend_positive_percentage">
          <ng-container *ngIf="trendIsEdited !== 'positive'">
            <div
              *ngIf="
                positiveSoftSkills && positiveSoftSkills.length;
                else noSoftSkills
              ">
              <div
                *ngFor="let softSkill of positiveSoftSkills; let i = index"
                class="sbi-widget_trend_ameliorative_percentage_child">
                <img
                  class="trend-icon"
                  [src]="
                    utilityService.getSanitizeUrl(
                      softSkill.argument?.filestorage?.path ?? ''
                    )
                  " />
                <div class="trend-label">{{ softSkill.name }}</div>
                <div class="trend-percentage">{{ softSkill.percentage }}%</div>
              </div>
            </div>

            <!-- Template alternativo -->
            <ng-template #noSoftSkills>
              <div class="no-soft-skills-label">Non ci sono soft skills</div>
            </ng-template>
          </ng-container>

          <!-- Inizio modifica delle competenze trasversali positive -->
          <div *ngIf="trendIsEdited === 'positive'" class="mt-2">
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="firstReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>
              <input
                class="h-25"
                [(ngModel)]="firstReviewSoftSkills.percentage"
                (ngModelChange)="
                  onPercentageChange($event, firstReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="secondReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>

              <input
                class="h-25"
                [(ngModel)]="secondReviewSoftSkills.percentage"
                (ngModelChange)="
                  onPercentageChange($event, secondReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
            <div class="sbi-widget_trend_ameliorative_percentage_child">
              <nz-select
                [nzAllowClear]="true"
                class="w-100 custom-input"
                nzMode="default"
                nzShowSearch
                nzPlaceHolder="Cerca competenza"
                [(ngModel)]="thirdReviewSoftSkills.argument_id">
                <nz-option
                  *ngFor="let softSkill of softSkills"
                  [nzLabel]="softSkill.alias"
                  [nzValue]="softSkill.id"></nz-option>
              </nz-select>

              <input
                class="h-25"
                [(ngModel)]="thirdReviewSoftSkills.percentage"
                (ngModelChange)="
                  thirdReviewSoftSkills($event, firstReviewSoftSkills)
                "
                nz-input
                placeholder="50%"
                type="number"
                min="0"
                max="100" />
            </div>
          </div>
          <!-- Fine modifica delle competenze trasversali -->

          <button class="generic-edit-btn">
            <div
              *ngIf="trendIsEdited !== 'positive'"
              (click)="editTrend('positive')">
              <img src="assets/images/Sbi/edit.svg" alt="" />
              modifica
            </div>

            <span
              (click)="saveTrend('positive')"
              *ngIf="trendIsEdited === 'positive'"
              >salva</span
            >
          </button>
        </div>
      </div>
      <!-- Fine Trend a sinistra parte Positiva -->
    </div>

    <div class="sbi-widget_filtered_card">
      <div *ngIf="sbisIsNotEmpty()" class="sbi-widget_filtered_card_label">
        <div class="text">Ecco gli SBI più rilevanti.</div>
        <button (click)="redirectTo()" class="view_all">Vedi tutto</button>
      </div>

      <div class="sbi-widget_filtered_card_list">
        <ng-container *ngIf="selectedTrend === 'migliorative'">
          <div
            *ngFor="let sbi of migliorativeSbis"
            class="sbi-widget_filtered_card_list_item migliorative">
            <div class="sbi-widget_filtered_card_list_item_avatars">
              <div class="logo-circle">
                <img
                  [src]="sanitizeImg(sbi?.project?.filestorage?.path || null)"
                  alt="Logo" />
              </div>
              <div class="profile-picture">
                <img
                  [src]="sanitizeImg(sbi.receiver.filestorage.path)"
                  alt="Foto profilo" />
              </div>
              <div class="icon-badge">
                <img
                  src="assets/images/Sbi/migliorativo.svg"
                  alt="Icona trend" />
              </div>
            </div>

            <div class="sbi-widget_filtered_card_list_item_content">
              <div class="name">
                {{ sbi.receiver.first_name + ' ' + sbi.receiver.last_name }}
              </div>
              <div *ngIf="filteredCardToEdited !== sbi.id" class="sensibilty">
                {{ sbi.alias || 'Sensibilità elevata' }}
              </div>
              <div *ngIf="filteredCardToEdited === sbi.id">
                <input
                  maxlength="45"
                  class="h-25"
                  [(ngModel)]="filteredSbiEditedAlias"
                  nz-input
                  placeholder="Inserire titolo"
                  type="text" />
              </div>
            </div>

            <div class="sbi-widget_filtered_card_list_item_calendar">
              <img
                src="assets/images/Sbi/calendar_light.svg"
                alt="calendar_light" />
              <div>{{ sbi.reported_at | date: 'dd/MM/yyyy' }}</div>
            </div>

            <button
              (click)="goToSbi(sbi)"
              class="sbi-widget_filtered_card_list_item_details">
              Dettaglio
            </button>

            <button class="generic-edit-btn">
              <div
                *ngIf="filteredCardToEdited !== sbi.id"
                (click)="allowEditFilteredCard(sbi)">
                <img src="assets/images/Sbi/edit.svg" alt="" />
                modifica
              </div>
              <span
                (click)="sendEditedFilteredWidget(sbi)"
                *ngIf="filteredCardToEdited === sbi.id"
                >salva</span
              >
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedTrend === 'positive'">
          <div
            *ngFor="let sbi of positiveSbis"
            class="sbi-widget_filtered_card_list_item positive">
            <div class="sbi-widget_filtered_card_list_item_avatars">
              <div class="logo-circle">
                <img
                  [src]="sanitizeImg(sbi?.project?.filestorage?.path || null)"
                  alt="Logo" />
              </div>
              <div class="profile-picture">
                <img
                  [src]="sanitizeImg(sbi.receiver.filestorage.path)"
                  alt="Foto profilo" />
              </div>
              <div class="icon-badge">
                <img
                  src="assets/images/Sbi/migliorativo.svg"
                  alt="Icona trend" />
              </div>
            </div>

            <div class="sbi-widget_filtered_card_list_item_content">
              <div class="name">
                {{ sbi.receiver.first_name + ' ' + sbi.receiver.last_name }}
              </div>
              <div *ngIf="filteredCardToEdited !== sbi.id" class="sensibilty">
                {{ sbi.alias || 'Sensibilità elevata' }}
              </div>
              <div *ngIf="filteredCardToEdited === sbi.id">
                <input
                  maxlength="45"
                  class="h-25"
                  [(ngModel)]="filteredSbiEditedAlias"
                  nz-input
                  placeholder="Inserire titolo"
                  type="text" />
              </div>
            </div>

            <div class="sbi-widget_filtered_card_list_item_calendar">
              <img
                src="assets/images/Sbi/calendar_light.svg"
                alt="calendar_light" />
              <div>{{ sbi.reported_at | date: 'dd/MM/yyyy' }}</div>
            </div>

            <button
              (click)="goToSbi(sbi)"
              class="sbi-widget_filtered_card_list_item_details">
              Dettaglio
            </button>

            <button class="generic-edit-btn">
              <div
                *ngIf="filteredCardToEdited !== sbi.id"
                (click)="allowEditFilteredCard(sbi)">
                <img src="assets/images/Sbi/edit.svg" alt="" />
                modifica
              </div>
              <span
                (click)="sendEditedFilteredWidget(sbi)"
                *ngIf="filteredCardToEdited === sbi.id"
                >salva</span
              >
            </button>
          </div>
        </ng-container>
      </div>

      <div class="sbi-widget_resume">
        <nz-collapse
          *ngIf="sbis.length > 0"
          [nzExpandIconPosition]="'right'"
          [nzAccordion]="true"
          class="mt-2">
          <nz-collapse-panel [nzHeader]="HeaderTemplate" [nzActive]="true">
            <!-- INIZIO CONTENUTO -->
            <div
              *ngIf="!editorOpening"
              class="camillo-content custom-editor-output-css"
              [innerHTML]="lastReview.note"></div>

            <div class="camillo-editor">
              <angular-editor
                [(ngModel)]="lastReview.note"
                *ngIf="editorOpening"
                [config]="editorConfig"></angular-editor>
            </div>
            <!-- FINE CONTENUTO -->

            <ng-template #HeaderTemplate>
              <nz-row
                class="d-flex align-items-center w-100"
                nzJustify="space-between">
                <!-- Camillo profile -->
                <nz-col>
                  <div class="camillo">
                    <img
                      class="camillo-img"
                      src="assets/images/camillo/camillo-sbi.png"
                      alt="" />
                    <div class="camillo-say">Camillo ti dice...</div>
                  </div>
                </nz-col>
                <!-- End Camillo profile -->

                <!-- Note, Suggestion and Edit -->
                <nz-col>
                  <button
                    *ngIf="!editorOpening"
                    class="camillo-edit"
                    (click)="$event.stopPropagation(); onNoteEditClicked()">
                    <img src="assets/images/Sbi/edit.svg" alt="" />
                    modifica
                  </button>

                  <button
                    *ngIf="editorOpening"
                    class="camillo-submit_btn generic-btn-disable"
                    (click)="$event.stopPropagation(); onNoteSaveClicked()">
                    Salva
                  </button>
                </nz-col>
                <!-- End Note, Suggestion and Edit -->
              </nz-row>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
  </div>

  <ng-template [ngIf]="isLoading && !isEdit">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
  </ng-template>
</nz-card>
